import { getBotConstants } from '../constants';

const getProviderBot = (state, action) => {
    if (state === undefined) {
        return {
            provederBots: [],
            loading: true,
            error: false,
        };
    }

    switch (action.type) {
        case getBotConstants.GET_BOT_REQUEST:
            return {
                provederBots: [],
                loading: true,
                error: false,
            };

        case getBotConstants.GET_BOT_SUCCESS:
            return {
                provederBots: action.payload,
                loading: false,
                error: false,
            };

        case getBotConstants.GET_BOT_FAILURE:
            return {
                provederBots: [],
                loading: false,
                error: true,
            };

        default:
            return state;
    }
};

export default getProviderBot;
